angular
  .module('components.planodiretor', [
    'ui.router'
  ]);
